import React, { useCallback, useLayoutEffect, useMemo } from 'react';
import Animated from 'react-native-reanimated';
import { useAppSelector } from 'store/hooks';
import { AppView, Button, ButtonGroup, rem, SCROLL_INDICATOR_INSETS, withAnimatedNavigationHeader, } from 'design-system';
import { HEIGHT } from 'design-system/Button';
import EmptyComponent from 'design-system/EmptyComponent';
import FlatListItemCard from 'design-system/FlatListItemCard';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import StatusBar from 'design-system/StatusBar';
import { useDisableAndroidBackButton } from 'hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useStyles from 'hooks/useStyles';
import { tierThemes } from 'features/premium/benefits';
import TierBenefit from 'features/premium/components/TierBenefit';
import TierFlatListFooter from 'features/premium/components/TierFlatListFooter';
import { selectFilteredBenefitsDataForTierFlattened } from 'features/premium/selectors';
import createStyleSheets from 'utils/createStyleSheets';
const strings = {
    greatThanks: 'Great, thanks!',
    youNowHaveAccess: 'You now have access to the best features on the market! You will not get charged!',
};
const DeleteReverseTrialAcknowledgeScreen = withAnimatedNavigationHeader(({ navigation, route, scrollHandler }) => {
    useLayoutEffect(() => {
        navigation.setOptions({
            headerLeft: EmptyComponent,
            gestureEnabled: false,
        });
    }, []);
    useDisableAndroidBackButton();
    const onPressStart = useCallback(async () => {
        navigation.popToTop();
        navigation.navigateDeprecated('DeleteReverseTrialSetup');
    }, []);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT + rem(16), paddingHorizontalStyle);
    const benefits = useAppSelector((store) => selectFilteredBenefitsDataForTierFlattened(store, route.params.reverseTrialTier));
    const styles = useStyles(styleSet);
    const tier = route.params.reverseTrialTier;
    const title = `Welcome to ${tierThemes[tier].name}!`;
    const renderHeader = useMemo(() => (<ScreenInfoHeader title={title} subTitle={strings.youNowHaveAccess} smallSubTitle/>), [title]);
    const renderItem = useCallback(({ item, index }) => (<FlatListItemCard style={styles.card} itemsLength={benefits.length} index={index}>
            <TierBenefit item={item} customIcon={item.customData?.customIcon} customName={item.customData?.customName} customDescription={item.customData?.customDescription}/>
          </FlatListItemCard>), [benefits.length, styles.card]);
    const renderFooter = useMemo(() => <TierFlatListFooter />, []);
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <Animated.FlatList onScroll={scrollHandler} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} scrollEventThrottle={16} contentContainerStyle={paddingBottom} ListFooterComponent={renderFooter} ListHeaderComponent={renderHeader} data={benefits} renderItem={renderItem}/>
          <ButtonGroup type="floating" margins>
            <Button title={strings.greatThanks} brand onPress={onPressStart} testID="acknowledgeButton"/>
          </ButtonGroup>
        </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styleSet = createStyleSheets((colors) => ({
    card: {
        backgroundColor: colors.cards.onDark,
    },
}));
export default DeleteReverseTrialAcknowledgeScreen;
